export { Brands as default } from '@boutique/brands'
